import apiFetch from "@/app/auth/apiFetch";
import type { NavigateFunction } from "react-router-dom";

const API_URL = import.meta.env.VITE_API_URL;

export interface InterestListItem {
  id: number;
  name: string;
  interest_type: string | null;
  url: string | null;
  follower_count: number | null;
  external_ref: string | null;
  candidate_count: number;
}

export interface PaginatedInterestsResponse {
  items: InterestListItem[];
  total: number;
  page: number;
  size: number;
  pages: number;
}

export async function listInterests(
  navigate: NavigateFunction,
  params?: { page?: number; size?: number; sort_by?: string; sort_order?: string; interest_type?: string }
): Promise<PaginatedInterestsResponse> {
  const q = new URLSearchParams();
  q.set("page", String(params?.page ?? 1));
  q.set("size", String(params?.size ?? 25));
  if (params?.sort_by) q.set("sort_by", params.sort_by);
  if (params?.sort_order) q.set("sort_order", params.sort_order);
  if (params?.interest_type) q.set("interest_type", params.interest_type);
  const url = `${API_URL}/interests?${q.toString()}`;
  const res = await apiFetch(url, { method: "GET" }, navigate);
  if (!res?.ok) throw new Error("Erreur lors du chargement des centres d'intérêt");
  return res.json();
}
